import React from "react";
import { useSelector } from "react-redux";
import styles from "../../styles/VideoPreview.module.scss";
import FeaturedVideo from "../ContentHome/FeaturedVideo";
import usePageHeading from "@src/customHooks/usePageHeading";

const VideoPreview = () => {

  // FETCHING STATES FROM REDUCER
  const videoItem = useSelector(
    (state) => state?.courseContentReducer?.apiResADD_PREVIEW_VIDEO_CONTENT
  );

  usePageHeading({ heading: videoItem?.name });

  return (
    <div className={styles.videoPreview}>
      <FeaturedVideo videoItem={videoItem} expandedDesc />
    </div>
  );
};

export default VideoPreview;
